// RFC Types for Client Components
// These should match the Prisma enums from the API

export enum RfcStatus {
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED',
  CLIENT_REVIEW = 'CLIENT_REVIEW',
  BROKER_REVIEW = 'BROKER_REVIEW',
  BROKER_APPROVED = 'BROKER_APPROVED',
  CLIENT_APPROVED = 'CLIENT_APPROVED',
  MSA_PENDING = 'MSA_PENDING',
  MSA_SENT = 'MSA_SENT',
  MSA_SIGNED = 'MSA_SIGNED',
  CBS_PROCESSING = 'CBS_PROCESSING',
  COMPLETED = 'COMPLETED',
  REJECTED = 'REJECTED',
  ON_HOLD = 'ON_HOLD',
  ARCHIVED = 'ARCHIVED',
}

export type RfcActorRole = 'client' | 'broker' | 'internal';

/**
 * RFC statuses that represent work awaiting the given actor's action. Powers the
 * "Action Required" filter on the RFC lists. Kept in sync with the status-based
 * Pipeline badge count in the API (`clients.rfc.pendingActionCount`).
 */
export function getActionRequiredRfcStatuses(role: RfcActorRole): RfcStatus[] {
  switch (role) {
    case 'broker':
      return [RfcStatus.BROKER_REVIEW];
    case 'internal':
      return [RfcStatus.SUBMITTED, RfcStatus.CLIENT_REVIEW];
    case 'client':
    default:
      return [
        RfcStatus.SUBMITTED,
        RfcStatus.CLIENT_REVIEW,
        RfcStatus.BROKER_APPROVED,
        RfcStatus.MSA_PENDING,
      ];
  }
}

export enum RfcStep {
  INITIAL = 'INITIAL',
  SECTION_125_FORM_GROUP_INFO = 'SECTION_125_FORM_GROUP_INFO',
  SECTION_125_FORM_ADMIN = 'SECTION_125_FORM_ADMIN',
  SECTION_125_FORM_CONTACTS = 'SECTION_125_FORM_CONTACTS',
  SECTION_125_FORM_PAYROLL_INFO = 'SECTION_125_FORM_PAYROLL_INFO',
  SECTION_125_FORM_AGENT = 'SECTION_125_FORM_AGENT',
  MEC_FORM_GROUP_INFO = 'MEC_FORM_GROUP_INFO',
  MEC_FORM_ADMIN = 'MEC_FORM_ADMIN',
  MEC_FORM_CONTACTS = 'MEC_FORM_CONTACTS',
  MEC_FORM_PAYROLL_INFO = 'MEC_FORM_PAYROLL_INFO',
  MEC_FORM_AGENT = 'MEC_FORM_AGENT',
  ACH_FORM = 'ACH_FORM',
  CLIENT_PORTAL_ACCESS = 'CLIENT_PORTAL_ACCESS',
  REVIEW = 'REVIEW',
}

export enum RfcAction {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  SUBMITTED = 'SUBMITTED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  PROCESSED = 'PROCESSED',
  COMPLETED = 'COMPLETED',
  BROKER_APPROVED = 'BROKER_APPROVED',
  BROKER_REJECTED = 'BROKER_REJECTED',
  MSA_SENT = 'MSA_SENT',
  MSA_SIGNED = 'MSA_SIGNED',
  MSA_VOIDED = 'MSA_VOIDED',
  ATTACHMENT_ADDED = 'ATTACHMENT_ADDED',
  ATTACHMENT_REMOVED = 'ATTACHMENT_REMOVED',
  STATUS_CHANGED = 'STATUS_CHANGED',
  INTERNAL_UPDATED = 'INTERNAL_UPDATED',
  PASSWORD_RESET = 'PASSWORD_RESET',
  ACCESSED = 'ACCESSED',
  PROPOSAL_SAVED = 'PROPOSAL_SAVED',
  NOTE_ADDED = 'NOTE_ADDED',
  NOTE_UPDATED = 'NOTE_UPDATED',
  NOTE_DELETED = 'NOTE_DELETED',
  PDF_GENERATED = 'PDF_GENERATED',
}

export enum RfcAttachmentType {
  CENSUS = 'CENSUS',
  LOCATION_DETAILS = 'LOCATION_DETAILS',
  BANK_LETTER = 'BANK_LETTER',
  VOIDED_CHECK = 'VOIDED_CHECK',
  SIGNED_ACH = 'SIGNED_ACH',
  OTHER = 'OTHER',
}
